import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { registerUser, selectAuthError, selectAuthStatus } from "./authSlice";
import countrycode from "../../data/countrycode.json";
import toast from "react-hot-toast";
import { selectCurrentUser } from "../auth/authSlice";
import { getSiteName } from "../../api/axios";
const RegisterForm = () => {
  const user = useSelector(selectCurrentUser);
  const [formData, setFormData] = useState({
    title: "",
    agencyName: "",
    name: "",
    lname: "",
    email: "",
    confirmEmail: "",
    password: "",
    password_confirmation: "",
    nationality: "",
    countrycode: "91",
    mobile: "",
    // UserType: 2,
    VIPAgency: 0,
    UserType: (getSiteName() === 'franchise_goertrip') ? 6 : 2,
  });


  const [showNationalityDropdown, setShowNationalityDropdown] = useState(false);
  const [allNationalities] = useState(countrycode);
  const [initialNationalities] = useState(countrycode.slice(0, 10));
  const [filteredNationalities, setFilteredNationalities] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const status = useSelector(selectAuthStatus);
  const error = useSelector(selectAuthError);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (status === "loading") return;

    const requiredFields = [
      "title",
      "agencyName",
      "fname",
      "lname",
      "email",
      "confirmEmail",
      "password",
      "password_confirmation",
    ];
    const missingFields = requiredFields.filter((field) => !formData[field]);

    if (missingFields.length > 0) {
      toast.error(`Please fill in all required fields: ${missingFields.join(", ")}`);
      return;
    }

    if (formData.password !== formData.password_confirmation) {
      toast.error("Passwords don't match!");
      return;
    }

    if (formData.email !== formData.confirmEmail) {
      toast.error("Emails don't match!");
      return;
    }
    const resultAction = await dispatch(registerUser(formData));

    if (registerUser.fulfilled.match(resultAction)) {
      if (resultAction?.payload?.status && resultAction?.payload?.token) {
        toast.success("Registration Successfull");
        navigate("/");
      } else {
        toast.error(resultAction.payload.message);
      }
    }
  };

  const handleNationalitySelect = (country) => {
    setFormData((prev) => ({
      ...prev,
      nationality: country.name,
      countrycode: country.dial_code,
    }));
    setShowNationalityDropdown(false);
  };

  const handleNationalityFocus = () => {
    setShowNationalityDropdown(true);
    if (!formData.nationality) {
      setFilteredNationalities(initialNationalities);
    } else {
      const filtered = allNationalities.filter((country) =>
        country.name.toLowerCase().includes(formData.nationality.toLowerCase())
      );
      setFilteredNationalities(filtered);
    }
  };

  const handleNationalityInputChange = (e) => {
    const value = e.target.value;
    setFormData((prev) => ({
      ...prev,
      nationality: value,
    }));

    if (value) {
      const filtered = allNationalities.filter((country) => country.name.toLowerCase().includes(value.toLowerCase()));
      setFilteredNationalities(filtered);
    } else {
      setFilteredNationalities(initialNationalities);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".nationality-input-container")) {
        setShowNationalityDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const isLoggedIn = user?.token || false;
    if (isLoggedIn) {
      navigate("/", { replace: true });
    }
  }, [navigate]);
  return (
    <div className="max-w-2xl mx-auto mt-10 p-6 bg-white rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-6 text-center">Register</h2>
      {error && (
        <div className="mb-4 p-2 bg-red-100 text-red-700 rounded">{error.message || "Registration failed"}</div>
      )}

      <form onSubmit={handleSubmit} noValidate>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-2" htmlFor="title">
              Title
            </label>
            <select
              id="title"
              name="title"
              required
              value={formData.title}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Your Title</option>
              <option value="Mr">Mr</option>
              <option value="Ms">Ms</option>
              <option value="Mrs">Mrs</option>
            </select>
          </div>

          <div>
            <label className="block text-gray-700 mb-2" htmlFor="company">
              Company Name
            </label>
            <input
              type="text"
              id="company"
              name="agencyName"
              value={formData.agencyName}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-2" htmlFor="fname">
              First Name
            </label>
            <input
              type="text"
              id="fname"
              name="fname"
              value={formData.fname}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2" htmlFor="lname">
              Last Name
            </label>
            <input
              type="text"
              id="lname"
              name="lname"
              value={formData.lname}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-gray-700 mb-2" htmlFor="email">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2" htmlFor="confirmEmail">
              Confirm Email
            </label>
            <input
              type="email"
              id="confirmEmail"
              name="confirmEmail"
              value={formData.confirmEmail}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div className="nationality-input-container relative">
            <label className="block text-gray-700 mb-2" htmlFor="nationality">
              Country
            </label>
            <input
              type="text"
              id="nationality"
              value={formData?.countrycode || ""}
              onChange={handleNationalityInputChange}
              onFocus={handleNationalityFocus}
              placeholder="Enter Nationality"
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {showNationalityDropdown && (
              <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-y-auto">
                {filteredNationalities.length === 0 ? (
                  <div className="px-4 py-2 text-gray-500 text-center">No nationalities found</div>
                ) : (
                  filteredNationalities.map((country) => (
                    <div
                      key={country.code}
                      onClick={() => handleNationalitySelect(country)}
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b border-gray-200 last:border-b-0"
                    >
                      +{country.dial_code} {country.name}
                    </div>
                  ))
                )}
              </div>
            )}
          </div>

          <div>
            <label className="block text-gray-700 mb-2" htmlFor="mobile">
              Mobile
            </label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter mobile number"
            />
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
          <div>
            <label className="block text-gray-700 mb-2" htmlFor="password">
              Password
            </label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
          <div>
            <label className="block text-gray-700 mb-2" htmlFor="password_confirmation">
              Confirm Password
            </label>
            <input
              type="password"
              id="password_confirmation"
              name="password_confirmation"
              value={formData.password_confirmation}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              required
            />
          </div>
        </div>

        <button
          type="submit"
          className="w-full bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          disabled={status === "loading"}
        >
          {status === "loading" ? "Registering..." : "Register"}
        </button>
      </form>
    </div>
  );
};

export default RegisterForm;
